import getAPI from './getAPI.js'

export default async function getSharepointSites() {
    const data = await getAPI('admin/sharepoint/sites');
    return data;
}
